import { useState, useCallback } from 'react';

const useForm = (value = {}) => {

  const [formData, setFormData] = useState(value)

  const onSetForm = useCallback((data) => {
    setFormData(data)
  // eslint-disable-next-line
  }, [])

  const onChangeWithRegExp = useCallback(e => {

    if(e.target.hasAttribute('regexp')){
      const exp = new RegExp(e.target.getAttribute('regexp'))

      if(exp.test(e.target.value)){
        return setFormData({
          ...formData,
          [e.target.name]: e.target.value
        })
      }

      return false
    }

    return setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }, [formData])

  const onChange = useCallback((e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }, [formData])

  const onChangeWithCallBack = useCallback(callback => (e) => {

    const newState = {
      ...formData,
      [e.target.name]: e.target.value
    }

    setFormData(newState)

    callback(newState)
  }, [formData])

  const onChangeNumber = useCallback(e => {

    const isDecimal =
      e.target.value && /^\d*(\.\d{0,4})?$/.test(e.target.value);

    if(isDecimal || isDecimal === ''){
      return setFormData({
        ...formData,
        [e.target.name]: e.target.value
      })
    }

  }, [formData])

  const onAddToList = useCallback(e => {

    setFormData({
      ...formData,
      [e.target.name]: [
        ...formData[e.target.name],
        e.target.value
      ]
    })
  }, [formData])

  const onDeleteToList = useCallback(e => {

    setFormData({
      ...formData,
      [e.target.name]: formData[e.target.name].filter(x => `${x.id}` !== `${e.target.value.id}`)
    })
  }, [formData])

  const onCreateUpdateToList = useCallback(e => {

    let newList = []

    const isExist = formData[e.target.name].find(x => +x.id === +e.target.value.id) || false

    if(isExist){
      newList = formData[e.target.name].map(x => {
        if(+x.id === +e.target.value.id){
          return e.target.value
        }

        return x
      })
    }
    else{
      newList = [
        ...formData[e.target.name],
        e.target.value
      ]
    }


    setFormData({
      ...formData,
      [e.target.name]: newList
    })
  }, [formData])

  const onCreateUpdateToListByKey = useCallback((key, e) => {

    let newList = []

    const isExist = formData[e.target.name].find(x => +x[key] === +e.target.value[key]) || false

    if(isExist){
      newList = formData[e.target.name].map(x => {
        if(+x[key] === +e.target.value[key]){
          return e.target.value
        }

        return x
      })
    }
    else{
      newList = [
        ...formData[e.target.name],
        e.target.value
      ]
    }
    console.log(newList)

    setFormData({
      ...formData,
      [e.target.name]: newList
    })
  }, [formData])

  const onSwitch = useCallback(e => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value ? +e.target.value : ''
    })
  }, [formData])

  const onSwitchWithCallBack = useCallback(callback => (e) => {

    const newState = {
      ...formData,
      [e.target.name]: e.target.value ? +e.target.value : ''
    }

    setFormData(newState)

    callback(newState)
  }, [formData])

  return [
    formData,
    {
      onChange,
      onAddToList,
      onSwitch,
      onSwitchWithCallBack,
      onChangeNumber,
      onSetForm,
      onCreateUpdateToList,
      onDeleteToList,
      onCreateUpdateToListByKey,
      onChangeWithCallBack,
      onChangeWithRegExp
    }
  ]

}

export default useForm